import { render, staticRenderFns } from "./SettingsDrawer.vue?vue&type=template&id=2b200538&scoped=true"
import script from "./SettingsDrawer.vue?vue&type=script&lang=ts"
export * from "./SettingsDrawer.vue?vue&type=script&lang=ts"
import style0 from "./SettingsDrawer.vue?vue&type=style&index=0&id=2b200538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b200538",
  null
  
)

export default component.exports